import React from "react";
import ReservationCardRecipients from '../../ReservationCard/tabs/ReservationCardRecipients';

class DeliveryStatusDataType extends React.Component{

  render() {
    return (
    	<div>
        <ReservationCardRecipients size="small" email={this.props.row} date_format={this.props.date_format} time_format={this.props.time_format} />
    	</div>
    );
  }

};

export default DeliveryStatusDataType